import axios from 'axios';
import { setAlert } from './alert';
import {
  GET_FAQ,
  GET_FAQS,
  FAQ_ERROR,
  DELETE_FAQ,
  ADD_FAQ,
  UPDATE_FAQ
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all FAQs
export const getFAQs = () => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/faqs/all`);
    dispatch({
      type: GET_FAQS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: FAQ_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get FAQ by ID
export const getFAQById = id => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/faqs/${id}`);

    dispatch({
      type: GET_FAQ,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: FAQ_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Create FAQ
export const createFAQ = (formData, navigate) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(`${API_URL}/faqs`, formData, config);
    dispatch({
      type: ADD_FAQ,
      payload: res.data.data
    });

    dispatch(setAlert('FAQ Created', 'success'));
    
    if (navigate) {
      navigate('/inventory/v1.2/faqs');
    }
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: FAQ_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    
    return null;
  }
};

// Update FAQ
export const updateFAQ = (id, formData) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.put(`${API_URL}/faqs/${id}`, formData, config);

    dispatch({
      type: UPDATE_FAQ,
      payload: res.data.data
    });

    dispatch(setAlert('FAQ Updated', 'success'));
    return true;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: FAQ_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    return false;
  }
};

// Delete FAQ
export const deleteFAQ = id => async dispatch => {
  try {
    await axios.delete(`${API_URL}/faqs/${id}`);

    dispatch({
      type: DELETE_FAQ,
      payload: id
    });

    dispatch(setAlert('FAQ Removed', 'success'));
  } catch (err) {
    dispatch({
      type: FAQ_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};
